import React, { useContext } from "react";

import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { AccordionContext, useAccordionButton } from "react-bootstrap";

import Icon from "../../Icon/Icon";

function AccordionToggle({ children, eventKey }) {
  const { activeEventKey } = useContext(AccordionContext);
  const decoratedOnClick = useAccordionButton(eventKey);

  return (
    <div
      className="d-flex justify-content-between align-items-center py-2"
      onClick={decoratedOnClick}
    >
      <h3 className="mb-0 text-uppercase">{children}</h3>
      <Icon
        className="me-2"
        color="black"
        icon={activeEventKey === eventKey ? "chevronUp" : "chevronDown"}
        size={22}
      />
    </div>
  );
}

export default observer(AccordionToggle);

AccordionToggle.propTypes = {
  children: PropTypes.node.isRequired,
  eventKey: PropTypes.string,
};

AccordionToggle.defaultProps = {
  eventKey: null,
};
